













import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import Typography from '@/components/Rain/Typography/Typography.vue'

type positionType = 'left' | 'right' | 'bottom' | 'top'

@Component<BaseTooltip>({
    components: {
        Typography
    }
})
export default class BaseTooltip extends Vue {
    @Prop({ type: String, required: false, default: 'top' })
    public readonly position!: positionType
    @Prop({ type: String, required: false, default: '' })
    public readonly title!: string

    public get titleSliced() {
        return this.title.slice(0, 50)
    }
}
